<template>
  <el-row id="con" :gutter="0">
    <el-col :xs="12" :sm="8" :md="4" :lg="4" :xl="4">
      <span :class="curClass('首页')" @click="changeTab('首页')">首页</span>
    </el-col>
    <el-col :xs="12" :sm="8" :md="4" :lg="4" :xl="4">
      <span :class="curClass('走进世有')" @click="changeTab('走进世有')"
        >走进世有</span
      >
    </el-col>
    <el-col :xs="12" :sm="8" :md="4" :lg="4" :xl="4">
      <span :class="curClass('产品展示')" @click="changeTab('产品展示')"
        >产品展示</span
      >
    </el-col>
    <el-col :xs="12" :sm="8" :md="4" :lg="4" :xl="4">
      <span :class="curClass('成功案例')" @click="changeTab('成功案例')"
        >成功案例</span
      >
    </el-col>
    <el-col :xs="12" :sm="8" :md="4" :lg="4" :xl="4">
      <span :class="curClass('新闻中心')" @click="changeTab('新闻中心')"
        >新闻中心</span
      >
    </el-col>
    <el-col :xs="12" :sm="8" :md="4" :lg="4" :xl="4">
      <span :class="curClass('售后服务')" @click="changeTab('售后服务')"
        >售后服务</span
      >
    </el-col>
  </el-row>
</template>

<style scoped>
#con {
  width: 100%;
  background-color: #ffffff;
  overflow: hidden;
  user-select: none;
  text-align: center;
}
#con span {
  font-size: 18px;
  color: #303133;
  cursor: pointer;
  user-select: none;
  padding: 16px 0;
  transition: all 0.2s;
}
#con .active {
  color: #ffffff;
  padding: 8px 32px;
  background-color: #409eff;
  border-radius: 1000px;
}
.el-col {
  padding: 8px 0;
}
</style>

<script>
export default {
  name: "Select",
  props: ["cur"],
  data() {
    return {};
  },
  methods: {
    /*通过父组件传递近来的数据来判断显示当前高亮*/
    curClass: function(str) {
      return { active: str == this.cur };
    },
    /*向父组件传递信息，更改当前高亮*/
    changeTab: function(str) {
      this.$emit("change-tab", str);
    }
  },
  mounted() {}
};
</script>
